import React from 'react';
import ReportHeader from '../component/ReportHeader';
import ReportDetails from '../component/ReportDetails';
import ReportGuidelines from './ReportGuidelines';

export default class ReportCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'report-card'}>
        <div className={'report-user'}>
          <ReportHeader
            selfieUrl={this.props.selfieUrl}
            verfiedStatus={this.props.verfiedStatus}
            personName={this.props.personName}
            docType={this.props.docType}
          />

          {this.props.pageNo === '1' ? (
            <ReportDetails
              isIdMismatch={this.props.isIdMismatch}
              isFaceMatched={this.props.isFaceMatched}
              details={this.props.details}
              matchedInformation={this.props.matchedInformation}
              isMisMatch={this.props.isMisMatch}
              isInfoUnavailable={this.props.isInfoUnavailable}
              error={this.props.error}
            />
          ) : (
            <ReportGuidelines docType={this.props.docType} />
          )}
        </div>
      </div>
    );
  }
}

ReportCard.defaultProps = {
  selfieUrl: `https://ui-avatars.com/api/?size=110&name=User Name`,
  verfiedStatus: null,
  personName: null,
  docType: null,
  isIdMismatch: null,
  isFaceMatched: null,
  details: {},
  matchedInformation: {},
  isMisMatch: null,
  isInfoUnavailable: null,
  pageNo: null,
  error: false
};
